module.exports = __webpack_public_path__ + "925b140bacf5b177b588e8037cc00de8.svg";